export const FORUMS_RESET_STATE = 'FORUMS_RESET_STATE';
export const FORUMS_CURRENT_ITEM = 'FORUMS_CURRENT_ITEM';

export const FORUMS_REQUEST_LOADING = 'FORUMS_REQUEST_LOADING';
export const FORUMS_REQUEST_SUCCESS = 'FORUMS_REQUEST_SUCCESS';
export const FORUMS_REQUEST_FAILED = 'FORUMS_REQUEST_FAILED';

export const FORUMS_CURRENT_ACTION = 'FORUMS_CURRENT_ACTION';
export const FORUMS_RESET_ACTION = 'FORUMS_RESET_ACTION';